var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeadframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 792 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 666.29,
    y1: 188.53,
    x2: 125.71,
    y2: 188.53,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 565.72,
    y: 104.67,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(1206.14 377.06) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 491.02,
    y: 104.67,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(1056.74 377.06) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 416.32,
    y: 104.67,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(907.34 377.06) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 419.18,
    y: 328.14,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(913.07 823.99) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 229.09,
    y: 328.14,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(532.87 823.99) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150.97,
    y: 328.14,
    width: 74.7,
    height: 167.71,
    rx: 35.27,
    ry: 35.27,
    transform: "translate(376.64 823.99) rotate(-180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 666.29,
    y1: 411.99,
    x2: 125.71,
    y2: 411.99,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650.17,5.71H141.83c-25.43,0-46.12,20.69-46.12,46.12v508.34c0,25.43,20.69,46.12,46.12,46.12h508.34c25.43,0,46.12-20.69,46.12-46.12V51.83c0-25.43-20.69-46.12-46.12-46.12ZM646.89,520.78c0,19.92-16.2,36.12-36.12,36.12H181.22c-19.92,0-36.12-16.2-36.12-36.12V91.22c0-19.92,16.2-36.12,36.12-36.12h429.55c19.92,0,36.12,16.2,36.12,36.12v429.55Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeadframe);
export default __webpack_public_path__ + "static/media/beadframe.43ee774712431383f23272ef62825fd2.svg";
export { ForwardRef as ReactComponent };